<template>

  <DocsPageTemplate apiDocs>
    <DocsPageSection title="Overview" anchor="#overview">
      For design guidance, see the page on <DocsInternalLink href="textfields" text="text fields" />.
    </DocsPageSection>
  </DocsPageTemplate>

</template>


<script>

  export default {};

</script>
